import { useRef, useEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

interface GallerySectionProps {
  images: string[];
}

export function GallerySection({ images }: GallerySectionProps) {
  const sectionRef = useRef<HTMLElement>(null);
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!gridRef.current || images.length === 0) return;
    gsap.fromTo(
      gridRef.current.children,
      { opacity: 0, scale: 0.95, y: 20 },
      {
        opacity: 1,
        scale: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
          toggleActions: "play none none none",
        },
      }
    );
  }, [images.length]);

  if (images.length === 0) return null;

  return (
    <section
      ref={sectionRef}
      className="bg-[#f7f7f7] px-6 py-24"
    >
      <div className="mx-auto max-w-5xl">
        <div
          ref={gridRef}
          className="columns-2 gap-4 sm:columns-3"
        >
          {images.slice(0, 5).map((src, i) => (
            <div key={i} className="mb-4 overflow-hidden rounded-2xl">
              <img
                src={src}
                alt=""
                className="w-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
